import { Link } from "react-router-dom";

import Menu from "./menu/Menu";

import logo from "../assets/images/logo.png";
import { useEffect, useRef } from "react";

export default function Header() {
    const menuRef = useRef<HTMLElement>(null);
    const logoRef = useRef<HTMLImageElement>(null);
    useEffect(() => {
        if (menuRef && menuRef.current && logoRef && logoRef.current) {
            const resize = () => {
                if (menuRef && menuRef.current && logoRef && logoRef.current) {
                    logoRef.current.style.marginTop =
                        menuRef.current.clientHeight + "px";
                }
            };
            resize()
            window.addEventListener("resize", resize);
        }
    }, [menuRef, logoRef]);

    return (
        <header className="flex w-11/12 flex-col items-center justify-between py-4">
            <Menu ref={menuRef}>
                {/* <Link to="/">T</Link> */}
                <Link to="/">Tutorial</Link>
                <Link to="/search">Pesquisar</Link>
                <Link to="/blog">Blog</Link>
                <Link to="/recommended">Melhores Vídeos</Link>
            </Menu>
            <Link
                className="focus:outline-dotted focus:outline-1 hocus:brightness-90"
                to="/"
            >
                <img
                    ref={logoRef}
                    className="w-36 pt-2 pb-4"
                    src={logo}
                    alt="Robozinho do XVideos"
                />
            </Link>
        </header>
    );
}
